import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Link } from "react-router-dom";

import UserService from "rc-app/services/UserService";
import { getCustomerProfile } from "rc-app/api/customerActionsApi";
import { getAgentProfile } from "rc-app/api/agentActionsApi";
import {
  getClientAdminByEmailId,
  getClientManagerByEmailId,
} from "rc-app/api/systemBusinessAdminActionApi";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "../Button";
import MobileDrawer from "../MobileDrawer";

import { GiHamburgerMenu } from "react-icons/gi";
// import { usePageTitle } from "rc-app/hooks/usePageTitle";
import Icon from "../Icons";
// import ThemeToggle from "../ThemeToggle";

export function Header(drawerOpen: any) {
  // const handleLogout = () => {
  //   window.history.pushState({}, "", "/");
  //   UserService.doLogout();
  // };

  // const pageTitle = usePageTitle(drawerOpen?.agencyName);

  console.log("drawerOpen", drawerOpen?.agencyName);

  const handleLogout = () => {
    UserService.doLogout();
  };

  const handleLogin = () => {
    UserService.doLogin();
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [logoLoadError, setLogoLoadError] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    setLogoLoadError(false);
  }, [drawerOpen?.agencyLogo]);

  React.useEffect(() => {
    if (!userMenuOpen) return undefined;
    const handler = (e: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target as Node)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [userMenuOpen]);

  // Display name: prefer the editable DB profile name so in-app renames show
  // here too. The JWT/Keycloak name (UserService.getFullName) is NOT updated by
  // an in-app rename, so it goes stale even after re-login. Role-aware fetch on
  // mount; silently falls back to the token name if the lookup fails/empty.
  const [dbName, setDbName] = React.useState<string>("");
  React.useEffect(() => {
    let alive = true;
    const userEmail = UserService.getUseremail();
    if (!userEmail) return undefined;
    (async () => {
      try {
        // Records vary in shape: customers use first_name/last_name; admins use
        // a single `name`. Handle both.
        const pickName = (o: any): string =>
          o?.name && String(o.name).trim()
            ? String(o.name).trim()
            : [o?.first_name, o?.last_name].filter(Boolean).join(" ");
        let name = "";
        if (UserService.hasRole("customer")) {
          const res: any = await getCustomerProfile(userEmail);
          name = pickName(res?.customer);
        } else if (UserService.hasRole("agent")) {
          const res: any = await getAgentProfile(userEmail);
          name = pickName(res?.agent);
        } else if (UserService.hasRole("agency_system_admin")) {
          const res: any = await getClientAdminByEmailId(userEmail);
          name = pickName(res?.agency_system_admin);
        } else if (UserService.hasRole("agency_business_admin")) {
          const res: any = await getClientManagerByEmailId(userEmail);
          name = pickName(res?.agency_business_admin);
        }
        if (alive && name && name.trim()) setDbName(name.trim());
      } catch {
        /* keep the JWT-name fallback */
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const fullName = dbName || UserService.getFullName?.();
  const email = UserService.getUseremail();

  const getInitials = (): string => {
    if (fullName && fullName.trim()) {
      const parts = fullName.trim().split(/\s+/);
      if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      return parts[0].slice(0, 2).toUpperCase();
    }
    if (email) return email.slice(0, 2).toUpperCase();
    return "U";
  };

  const getFirstName = (): string => {
    if (fullName && fullName.trim()) return fullName.trim().split(/\s+/)[0];
    if (email) {
      const prefix = email.split("@")[0].split(/[._-]/)[0];
      return prefix.charAt(0).toUpperCase() + prefix.slice(1);
    }
    return "User";
  };

  const getRoleLabel = (): string => {
    if (UserService.hasRole("super_admin")) return "Super Admin";
    if (UserService.hasRole("agency_business_admin")) return "Business Admin";
    if (UserService.hasRole("agency_system_admin")) return "System Admin";
    if (UserService.hasRole("agent")) return "Agent";
    // Customer/lead intentionally has NO role badge — "Lead" reads oddly to a
    // buyer logged into their own portal, so we render just their name.
    return "";
  };

  const getRoleColor = (): string => {
    if (UserService.hasRole("agency_business_admin")) return "#C4B5FD"; // violet
    if (UserService.hasRole("agency_system_admin")) return "#FB7185"; // rose
    if (UserService.hasRole("agent")) return "#38BDF8"; // sky
    if (UserService.hasRole("customer")) return "#34D399"; // emerald
    return "#F3CF08"; // OpenSky yellow (super_admin / fallback)
  };
  const pathname = window.location.pathname;

  const navigate = useNavigate();
  const navItems = [
    {
      name: "Product Features",
      slug: "/product_features",
    },
    {
      name: "Pricing",
      // slug: "/pricing",
      slug: "https://italia.1verse.live/pages/pricing-1",
    },
    {
      name: "Sell with us",
      slug: "/sell",
    },
    {
      name: "About us",
      // slug: "/about",
      slug: "https://italia.1verse.live/",
    },
  ];

  console.log("drawerOpen", drawerOpen);

  React.useEffect(() => {});

  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 1000);
    checkIsMobile();

    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);


  return (
    <>
      <header className="app-header mb-0 pt-3 pb-3 w-full max-w-screen-2xl">
        {!UserService.isLoggedIn() && (
          <>
            {/* large Screen */}
            <nav className=" justify-between items-center lg:px-10 xl:px-24 hidden lg:flex">
              <div className="mr-4 flex flex-row items-center">
                <div>
                  <Link
                    to="/"
                    className="flex items-center"
                    onClick={() => setSelectedItem("")}
                  >
                    {/* display on large and md */}
                    <img
                      alt="Opensky"
                      // src="https://storage.googleapis.com/oneverse-dev/realestate/1verse-logo-2.png"
                      // src="https://storage.googleapis.com/oneverse-dev/realestate/1verse_logo_pink.png"
                      src="/images/logoColoured.svg"
                      className="h-12 w-36 hidden lg:flex"
                    />
                    {/* <h5 className=" text-[#FF307A] text-2xl hidden md:flex">
                        1verse
                      </h5> */}
                  </Link>
                </div>
              </div>
              <ul className="flex">
                {navItems.map((item) => (
                  <li
                    key={item.name}
                    className="font-semibold font-sans hidden lg:flex"
                  >
                    <button
                      onClick={() => {
                        setSelectedItem(item.name);

                        if (item.slug == "/product_features" || "/sell") {
                          navigate(item.slug);
                        } else {
                          window.open(
                            item.slug,
                            "_blank",
                            "noopener noreferrer",
                          );
                        }
                      }}
                      className={`inline-block lg:text-lg  lg:px-2 xl:px-6 ${
                        selectedItem === item.name || pathname === item.slug
                          ? "text-[#FF307A]"
                          : " text-white"
                      }  py-2 duration-200`}
                    >
                      {item.name}
                    </button>
                  </li>
                ))}
              </ul>
              <div className="gap-3 hidden md:flex mr-2 justify-items-end">
                {/* <div className=" border border-gray-400 rounded-lg px-2 ">
                  <Select
                    label="logo"
                    ImgSrc={`https://storage.googleapis.com/oneverse-dev/realestate/img2.png`}
                    options={["English", "French", "Duch"]}
                    className="border-none font-semibold"
                  />
                </div> */}
                <Button
                  children="Login"
                  className="bg-[#FF307A] font-semibold px-6 py-2 rounded-md"
                  onClick={handleLogin}
                />
              </div>
            </nav>

            {/* Smaller Screen */}
            <div className="flex items-center lg:hidden flex-grow mx-4 md:mx-2">
              <div className="flex items-start w-1/2 sm:px-2 md:px-4  ">
                <Link to="/" className="flex items-center">
                  {/* display on xs */}
                  <img
                    alt="Opensky"
                    // src="https://storage.googleapis.com/oneverse-dev/realestate/1verse_logo_white.svg"
                    src="/images/logoColoured.svg"
                    className="h-12 w-38 lg:hidden "
                  />
                  {/* <h5 className=" text-[#FF307A] text-2xl  md:hidden">
                      1verse
                    </h5> */}
                </Link>
              </div>
              <div className="flex justify-end  w-1/2 px-2 md:px-4 ">
                {isMobile && (
                  <GiHamburgerMenu
                    className="text-white cursor-pointer"
                    size={28}
                    onClick={() => setMenuOpen(!menuOpen)}
                  />
                )}
                {/* <Button
                  children="Login"
                  className="bg-[#FF307A] font-semibold hidden lg:flex "
                  onClick={handleLogin}
                />
                <span
                  className="flex lg:hidden text-white"
                  onClick={handleLogin}
                >
                  <LoginIcon />
                </span> */}
              </div>
            </div>

            {isMobile && <MobileDrawer open={menuOpen} setOpen={setMenuOpen} />}
          </>
        )}

        {UserService.isLoggedIn() && (
          <nav
            className={`header-nav w-full flex items-center gap-2 ${
              drawerOpen.drawerOpen ? "justify-end" : "justify-between"
            } px-2 sm:px-3 md:px-4`}
          >
            {/* Left Side - Welcome Message */}
            {!drawerOpen.drawerOpen && (
              <div
                className={`header-brand flex gap-2 md:gap-3 items-center min-w-0 flex-1 text-white text-base md:text-xl font-extrabold ${
                  drawerOpen.drawerOpen ? "hidden md:block" : "block"
                }`}
              >
                {/* Role and pageTitle */}
                {UserService.hasRole("super_admin") && (
                  <Icon name="OpenSkyLogoWithText" className="w-24 h-9 md:w-32 md:h-12 flex-shrink-0" />
                )}
                {UserService.hasRole("super_admin") && (
                  <span className="text-sm sm:text-base md:text-xl truncate">Super Admin</span>
                )}
                {(UserService.hasRole("agency_business_admin") ||
                  UserService.hasRole("agency_system_admin") ||
                  UserService.hasRole("agent") ||
                  UserService.hasRole("customer")) &&
                  (drawerOpen?.agencyLogo && !logoLoadError ? (
                    <img
                      src={drawerOpen.agencyLogo}
                      alt={drawerOpen?.agencyName || "Agency"}
                      className="h-8 md:h-12 w-auto max-w-[130px] sm:max-w-[180px] md:max-w-[220px] object-contain"
                      onError={() => setLogoLoadError(true)}
                    />
                  ) : (
                    <span className="text-sm sm:text-base md:text-xl truncate">
                      {drawerOpen?.agencyName}
                    </span>
                  ))}
              </div>
            )}

            {/* Right Side - User menu */}
            <div className="header-actions flex items-center gap-2 sm:gap-3 flex-shrink-0">
              {UserService.hasRole("customer") && (() => {
                try {
                  const agencies = JSON.parse(sessionStorage.getItem("customerAgencies") || "[]");
                  if (agencies.length > 1) {
                    return (
                      <button
                        className="shrink-0 text-xs sm:text-sm font-medium px-2.5 sm:px-3 py-1.5 rounded-md bg-[#008564]/80 hover:bg-[#008564] text-white transition-colors whitespace-nowrap"
                        onClick={() => {
                          localStorage.removeItem("agencySlug");
                          navigate("/agency-select");
                        }}
                      >
                        <span className="hidden sm:inline">Switch Agency</span>
                        <span className="sm:hidden">Switch</span>
                      </button>
                    );
                  }
                } catch (_) {}
                return null;
              })()}

              <div className="relative" ref={userMenuRef}>
                <button
                  type="button"
                  onClick={() => setUserMenuOpen((prev) => !prev)}
                  className="flex items-center gap-2.5 pl-1.5 pr-2.5 py-1 rounded-full hover:bg-white/5 transition-colors"
                >
                  <div className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-white text-[11px] md:text-xs font-semibold tracking-wide">
                    {getInitials()}
                  </div>
                  <div className="flex flex-col items-start leading-tight min-w-0">
                    <span className="text-white text-xs sm:text-sm font-medium truncate max-w-[120px] sm:max-w-[160px]">{getFirstName()}</span>
                    {getRoleLabel() && (
                      <span
                        className="inline-block text-[10px] sm:text-[11px] font-semibold tracking-[0.06em] uppercase px-2 py-[2px] rounded-md truncate max-w-[120px] sm:max-w-[160px]"
                        style={{ color: getRoleColor(), backgroundColor: `${getRoleColor()}26` }}
                      >
                        {getRoleLabel()}
                      </span>
                    )}
                  </div>
                  <svg
                    className={`w-3 h-3 text-white/40 transition-transform ${userMenuOpen ? "rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {userMenuOpen && (
                  <div className="absolute right-0 mt-2 w-[calc(100vw-1.5rem)] max-w-[280px] sm:w-64 rounded-lg bg-[#1C2C3A] border border-white/10 shadow-2xl py-1.5 z-50">
                    <div className="px-4 py-3 border-b border-white/10">
                      <p className="text-white text-sm font-semibold truncate">{fullName || getFirstName()}</p>
                      <p className="text-white/55 text-xs truncate mt-0.5">{email}</p>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setUserMenuOpen(false);
                        setShowLogoutConfirm(true);
                      }}
                      className="w-full text-left px-4 py-2.5 text-sm text-white/85 hover:bg-white/5 transition-colors flex items-center gap-2.5"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Logout Confirmation Modal */}
            {showLogoutConfirm && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                <div className="bg-white rounded-xl shadow-xl p-6 w-80 flex flex-col gap-4">
                  <p className="text-gray-800 font-semibold text-base">Are you sure you want to logout?</p>
                  <div className="flex gap-3 justify-end">
                    <button
                      className="px-4 py-2 rounded-md text-sm font-medium text-gray-600 hover:bg-gray-100 transition-colors"
                      onClick={() => setShowLogoutConfirm(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="px-4 py-2 rounded-md text-sm font-medium bg-red-500 hover:bg-red-600 text-white transition-colors"
                      onClick={() => { setShowLogoutConfirm(false); handleLogout(); }}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            )}
          </nav>
        )}
      </header>
    </>
  );
}
